import { render, staticRenderFns } from "./StudentReferrer.vue?vue&type=template&id=7a930579&"
import script from "./StudentReferrer.vue?vue&type=script&lang=ts&"
export * from "./StudentReferrer.vue?vue&type=script&lang=ts&"
import style0 from "./StudentReferrer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports